/**
 * 퀴즈 타입 설정 파일
 * 
 * 이 파일은 프로젝트 전체에서 사용되는 퀴즈 타입을 중앙 관리합니다.
 * 새로운 퀴즈 타입을 추가할 때는 이 파일만 수정하면 됩니다.
 */

/**
 * 퀴즈 타입 정의
 * - value: 서버/DB에서 사용하는 타입 코드 (대문자)
 * - label: 사용자에게 표시되는 한글 이름
 * - categoryBased: 카테고리 선택 방식인지 여부 (true: 카테고리 선택, false: 레벨 선택)
 * - description: 타입에 대한 설명
 * - thumbnail: 썸네일 이미지 URL (사용자가 등록 예정)
 */
export const QUIZ_TYPES = {
    // 이미지 퀴즈 (카테고리 기반)
    IMG: {
        value: 'IMG',
        label: '이미지',
        categoryBased: true,
        description: '이미지 기반 퀴즈로 카테고리를 선택하여 문제를 구성합니다.',
        thumbnail: 'https://d1r6v24dyewnnj.cloudfront.net/util/images/1766107237113_as32bhz1ndh.png' // 썸네일 주소 등록 예정
    },
    
    // 타일 퀴즈 (카테고리 기반)
    TILE: {
        value: 'TILE',
        label: '타일 퀴즈',
        categoryBased: true,
        description: '타일 형태의 이미지 퀴즈로 카테고리를 선택하여 문제를 구성합니다.',
        thumbnail: 'https://d1r6v24dyewnnj.cloudfront.net/util/images/1766107241098_s9j5savzrne.png' // 썸네일 주소 등록 예정
    },
    
    // 가로세로 퀴즈 (레벨 기반)
    HV: {
        value: 'HV',
        label: '가로세로',
        categoryBased: false,
        description: '가로세로 퀴즈로 문제별 난이도 레벨을 설정합니다.',
        thumbnail: 'https://d1r6v24dyewnnj.cloudfront.net/util/images/1766107231019_mvtfeoy8heo.png' // 썸네일 주소 등록 예정
    },
    
    // 객관식 퀴즈 (레벨 기반)
    CHOICE: {
        value: 'CHOICE',
        label: '객관식',
        categoryBased: false,
        description: '4지선답 퀴즈로 문제별 난이도 레벨을 설정합니다.',
        thumbnail: 'https://d1r6v24dyewnnj.cloudfront.net/util/images/1766107251625_bhvkqqo09aw.png' // 썸네일 주소 등록 예정
    },
    
    // 기억력 퀴즈 (새로 추가)
    MEMORY: {
        value: 'MEMORY',
        label: '기억력',
        categoryBased: false, // 추후 필요에 따라 변경 가능
        description: '기억력을 테스트하는 퀴즈입니다.',
        thumbnail: 'https://d1r6v24dyewnnj.cloudfront.net/util/images/1766108160693_32ozmvjmmw3.png' // 썸네일 주소 등록 예정
    },
    
    // 색깔 퀴즈 (새로 추가)
    COLOR: {
        value: 'COLOR',
        label: '색깔퀴즈',
        categoryBased: false, // 추후 필요에 따라 변경 가능
        description: '색깔을 맞추는 퀴즈입니다.',
        thumbnail: 'https://d1r6v24dyewnnj.cloudfront.net/util/images/1766107259943_pprh3u3aj4.png' // 썸네일 주소 등록 예정
    },
    
    // 오십까지 퀴즈 (새로 추가)
    FIFTY: {
        value: 'FIFTY',
        label: '오십까지',
        categoryBased: false, // 추후 필요에 따라 변경 가능
        description: '50까지의 숫자를 다루는 퀴즈입니다.',
        thumbnail: 'https://d1r6v24dyewnnj.cloudfront.net/util/images/1766107256448_keouiuze9sn.png' // 썸네일 주소 등록 예정
    },
    
    // 넌센스퀴즈 
    NONSENSE: {
        value: 'NONSENSE',
        label: '넌센스 퀴즈',
        categoryBased: false,
        needsLevelSetting: false, // 레벨 설정 불필요 (초기화만 필요)
        description: '창의력으로 문제를 해결하세요!',
        thumbnail: 'https://d1r6v24dyewnnj.cloudfront.net/util/images/1767683407499_83m6gdwqyxu.png' // 썸네일 주소 등록 예정
    },
    
    // 그림퀴즈
    DRAWING: {
        value: 'DRAWING',
        label: '그림퀴즈',
        categoryBased: false,
        needsLevelSetting: false, // 레벨 설정 불필요 (초기화만 필요)
        description: '그림을 보고 연상되는 답을 맞추세요',
        thumbnail: 'https://d1r6v24dyewnnj.cloudfront.net/util/images/1767683411337_n5ues53yvfd.png' // 썸네일 주소 등록 예정
    },
    
    //어느쪽이 더 많을까?
    MANYMORE: {
        value: 'MANYMORE',
        label: '어느쪽이 더 많을까?',
        categoryBased: false, // 추후 필요에 따라 변경 가능
        description: '어느쪽이 더 많을까?',
        thumbnail: 'https://d1r6v24dyewnnj.cloudfront.net/util/images/1767683416300_ab7hrrvjv3p.png' // 썸네일 주소 등록 예정
    },
    
    // OX퀴즈
    OXQUIZ: {
        value: 'OXQUIZ',
        label: 'OX퀴즈',
        categoryBased: false, // 추후 필요에 따라 변경 가능
        description: '정답은 모 아니면 도',
        thumbnail: 'https://d1r6v24dyewnnj.cloudfront.net/util/images/1767683400341_8zf25xgvqq3.png' // 썸네일 주소 등록 예정
    },
    
    // DEFAULT (QuizList_Group에서 사용하는 기본 타입)
    DEFAULT: {
        value: 'DEFAULT',
        label: '이미지',
        categoryBased: true,
        description: '기본 이미지 퀴즈 타입입니다.',
        thumbnail: '' // 썸네일 주소 등록 예정
    },
    
    // NONE (QuizList_Group에서 사용)
    NONE: {
        value: 'NONE',
        label: '없음',
        categoryBased: true,
        description: '타입이 지정되지 않은 경우입니다.',
        thumbnail: '' // 썸네일 주소 등록 예정
    }
};

/**
 * 퀴즈 타입 옵션 리스트 (v-select 등에서 사용)
 * @param {Array<string>} excludeTypes - 제외할 타입 배열 (예: ['NONE', 'DEFAULT'])
 * @returns {Array<{label: string, value: string}>}
 */
export function getQuizTypeOptions(excludeTypes = []) {
    return Object.values(QUIZ_TYPES)
        .filter(type => !excludeTypes.includes(type.value))
        .map(type => ({
            label: type.label,
            value: type.value
        }));
}

/**
 * 퀴즈 타입별 라벨 가져오기
 * @param {string} typeValue - 퀴즈 타입 값
 * @returns {string} 타입 라벨
 */
export function getQuizTypeLabel(typeValue) {
    const type = Object.values(QUIZ_TYPES).find(t => t.value === typeValue);
    return type ? type.label : typeValue || '-';
}

/**
 * 퀴즈 타입별 썸네일 URL 가져오기
 * @param {string} typeValue - 퀴즈 타입 값
 * @returns {string} 썸네일 URL (없으면 null)
 */
export function getQuizTypeThumbnail(typeValue) {
    const type = Object.values(QUIZ_TYPES).find(t => t.value === typeValue);
    return type && type.thumbnail ? type.thumbnail : null;
}

/**
 * 카테고리 기반 타입인지 확인
 * @param {string} typeValue - 퀴즈 타입 값
 * @returns {boolean}
 */
export function isCategoryBasedType(typeValue) {
    const type = Object.values(QUIZ_TYPES).find(t => t.value === typeValue);
    return type ? type.categoryBased : false;
}

/**
 * 레벨 기반 타입인지 확인
 * @param {string} typeValue - 퀴즈 타입 값
 * @returns {boolean}
 */
export function isLevelBasedType(typeValue) {
    return !isCategoryBasedType(typeValue);
}

/**
 * 레벨 설정이 필요한 타입인지 확인 (DRAWING, NONSENSE는 레벨 설정 불필요)
 * @param {string} typeValue - 퀴즈 타입 값
 * @returns {boolean}
 */
export function needsLevelSetting(typeValue) {
    const type = Object.values(QUIZ_TYPES).find(t => t.value === typeValue);
    if (!type) return false;
    // categoryBased가 false이고 needsLevelSetting이 명시적으로 false가 아니면 레벨 설정 필요
    if (type.categoryBased === false) {
        return type.needsLevelSetting !== false;
    }
    return false;
}

/**
 * 카테고리 기반 타입 리스트 가져오기
 * @returns {Array<string>}
 */
export function getCategoryBasedTypes() {
    return Object.values(QUIZ_TYPES)
        .filter(type => type.categoryBased)
        .map(type => type.value);
}

/**
 * 레벨 기반 타입 리스트 가져오기
 * @returns {Array<string>}
 */
export function getLevelBasedTypes() {
    return Object.values(QUIZ_TYPES)
        .filter(type => !type.categoryBased)
        .map(type => type.value);
}

/**
 * QuizList_Group에서 사용하는 타입 옵션 (DEFAULT, TILE, HV, CHOICE 등)
 * @returns {Array<{label: string, value: string}>}
 */
export function getQuizListGroupTypeOptions() {
    return [
        QUIZ_TYPES.IMG,
        QUIZ_TYPES.TILE,
        QUIZ_TYPES.HV,
        QUIZ_TYPES.CHOICE,
        QUIZ_TYPES.MEMORY,
        QUIZ_TYPES.COLOR,
        QUIZ_TYPES.FIFTY,
        QUIZ_TYPES.NONSENSE,
        QUIZ_TYPES.OXQUIZ,
        QUIZ_TYPES.DRAWING,
        QUIZ_TYPES.MANYMORE
    ].map(type => ({
        label: type.label,
        value: type.value
    }));
}

/**
 * Game_MainQuizInfo에서 사용하는 타입 옵션 (IMG, TILE, HV, CHOICE)
 * @returns {Array<{label: string, value: string}>}
 */
export function getMainQuizInfoTypeOptions() {
    return [
        QUIZ_TYPES.IMG,
        QUIZ_TYPES.TILE,
        QUIZ_TYPES.HV,
        QUIZ_TYPES.CHOICE,
        QUIZ_TYPES.MEMORY,
        QUIZ_TYPES.COLOR,
        QUIZ_TYPES.FIFTY
    ].map(type => ({
        label: type.label,
        value: type.value
    }));
}

// 기본 export
export default {
    QUIZ_TYPES,
    getQuizTypeOptions,
    getQuizTypeLabel,
    getQuizTypeThumbnail,
    isCategoryBasedType,
    isLevelBasedType,
    needsLevelSetting,
    getCategoryBasedTypes,
    getLevelBasedTypes,
    getQuizListGroupTypeOptions,
    getMainQuizInfoTypeOptions
};

